import defaultValidators from "./validators";
const addGlobalValidators = (validators) => {
    validators.forEach(({ name, validator, errMsg }) => {
        defaultValidators.push({
            name,
            validator,
            errMsg
        });
    });
};
export default addGlobalValidators;
